"use strict";

const InputBaseControlComponent = require("../InputBaseControlComponent");
const _ = require("lodash");

class InputBaseBooleanControlComponent extends InputBaseControlComponent {
    /**
     * @schema.name Input Base Boolean Control
     *
     * @schema.configuration.label.name label
     * @schema.configuration.label.type string
     * @schema.configuration.label.default ""
     * @schema.configuration.label.required false
     *
     * @schema.configuration.value.name value
     * @schema.configuration.value.type boolean
     * @schema.configuration.value.default false
     * @schema.configuration.value.required true
     *
     */

    constructor(configOptions) {
        super(configOptions);
        this._label = _.get(configOptions, "label", "");
        this._value = _.get(configOptions, "value", false);
    }
    /*******************************************/
    /* START PUBLIC API METHODS */
    /*******************************************/

    /**
     * @schema.methods.setLabel.name setLabel
     * @schema.methods.setLabel.description Sets the display text of the control and returns an instance of the control for chainability
     * @schema.methods.setLabel.returns Instance of the control
     * @schema.methods.setLabel.parameters.newVal.name newVal
     * @schema.methods.setLabel.parameters.newVal.description The new display text
     * @schema.methods.setLabel.parameters.newVal.type string
     */
    setLabel(newVal) {
        this._label = newVal;
        this.emit("Label", this._label);
        return this;
    }
    /**
     * @schema.methods.getLabel.name getLabel
     * @schema.methods.getLabel.description Returns the display text of the control
     * @schema.methods.getLabel.returns string
     */
    getLabel() {
        return this._label;
    }
    get label() {
        return this.getLabel();
    }
    set label(newVal) {
        return this.setLabel(newVal);
    }

    /**
     * @schema.methods.setValue.name setValue
     * @schema.methods.setValue.description Sets the value and returns an instance of the control for chainability
     * @schema.methods.setValue.returns Instance of the control
     * @schema.methods.setValue.parameters.newVal.name newVal
     * @schema.methods.setValue.parameters.newVal.description The new value
     * @schema.methods.setValue.parameters.newVal.type boolean
     * @schema.methods.setValue.parameters.wasTriggeredByUser.name wasTriggeredByUser
     * @schema.methods.setValue.parameters.wasTriggeredByUser.description Flag alerting that this was a user-triggered change (optional)
     * @schema.methods.setValue.parameters.wasTriggeredByUser.required false
     * @schema.methods.setValue.parameters.wasTriggeredByUser.type boolean
     */
    setValue(newVal, wasTriggeredByUser) {
        let oldVal = _.cloneDeep(this._value);
        this._value = newVal;
        this.emit("Value", this._value, oldVal, wasTriggeredByUser);
        return this;
    }
    /**
     * @schema.methods.getValue.name getValue
     * @schema.methods.getValue.description Returns the value of the control
     * @schema.methods.getValue.returns boolean
     */
    getValue() {
        return this._value;
    }
    get value() {
        return this.getValue();
    }
    set value(newVal) {
        return this.setValue(newVal);
    }

    /**
     * @schema.methods.setOn.name setOn
     * @schema.methods.setOn.description Sets the on/selected state of the control and returns an instance of the control for chainability
     * @schema.methods.setOn.returns Instance of the control
     */
    setOn() {
        this.setValue(true);
    }
    /**
     * @schema.methods.isOn.name isOn
     * @schema.methods.isOn.description Returns the on/selected state of the control
     * @schema.methods.isOn.returns boolean
     */
    isOn() {
        return this.getValue();
    }

    /**
     * @schema.methods.setOff.name setOff
     * @schema.methods.setOff.description Sets the off/unselected state of the control and returns an instance of the control for chainability
     * @schema.methods.setOff.returns Instance of the control
     */
    setOff() {
        this.setValue(false);
    }
    /**
     * @schema.methods.isOff.name isOff
     * @schema.methods.isOff.description Returns the off/unselected state of the control
     * @schema.methods.isOff.returns boolean
     */
    isOff() {
        return !this.getValue();
    }

    /*******************************************/
    /* END PUBLIC API METHODS */
    /*******************************************/
}

module.exports = InputBaseBooleanControlComponent;
